import i18n from '@translations/i18n';
import { toast } from 'react-toastify';

import { confirmDialog } from './confirm-dialog';

const t = (key: string): string => String(i18n.t(key));

const confirmDelete = (title: string, onConfirm: () => void): void => {
  void confirmDialog({
    title,
    text: t('alerts.cannotUndo'),
    confirmLabel: t('common.delete'),
    danger: true,
  }).then((confirmed) => {
    if (confirmed) onConfirm();
  });
};

export const successMessage = (message: string): void => {
  toast.success(message);
};

export const errorMessage = (message: string): void => {
  toast.error(message);
};

export const altMessage = (
  action: (params?: unknown) => void,
  params?: unknown
): void => {
  confirmDelete(t('alerts.areYouSure'), () => action(params));
};

export const deleteImageAlert = (
  handleimageDelete: (func: (index: number) => void, index: number) => void,
  func: (index: number) => void,
  index: number
): void => {
  confirmDelete(t('alerts.deleteImage'), () => handleimageDelete(func, index));
};

export const deleteVideoAlert = (
  handleDeleteVideosRes: (index: number) => void,
  index: number
): void => {
  confirmDelete(t('alerts.deleteVideo'), () => handleDeleteVideosRes(index));
};

export const deleteAccountAlert = (handleDeleteAccountRes: () => void): void => {
  confirmDelete(t('alerts.deleteAccount'), handleDeleteAccountRes);
};

export const ratingsCompletedAlert = (handleContinue: () => void): void => {
  void confirmDialog({
    title: t('alerts.continueRatingTitle'),
    text: t('alerts.continueRatingText'),
    confirmLabel: t('alerts.continueRatingConfirm'),
  }).then((confirmed) => {
    if (confirmed) handleContinue();
  });
};
